export const Constants = {
      dispatchTypeS: [
      { value: 'NORMAL', text: 'Normal' },
      { value: 'EXPRESS', text: 'Express' }
      ],
    actionDispatch : [
        { value: 'Confirmar - Pendiente Picking', text: 'Confirmación de Picking', importable: false },
        { value: 'Despachar - Pendiente de Despacho', text: 'Confirmación de despacho', importable: false },
        { value: 'Recepcionar - Pendiente de Recepcion', text: 'Confirmación de recepción', importable: false },
        { value: 'Confirmar Despacho a Cliente', text: 'Confirmación de despacho a cliente', importable: true },
        { value: 'Recojo de Proveedor', text: 'Confirmación de recojo proveedor', importable: true },
        { value: 'Confirmar Devolución a Origen', text: 'Confirmación de devolución a origen', importable: true },
        { value: 'Recepcionar Seller - Pendiente de Recepcion', text: 'Confirmación de recepción', importable: false },        
    ],
    carrierDefault: 'Transporte genérico',
    typeEvent: [
        {stateId: 2, event: 'ORDER_DISPATCHED'},
        {stateId: 3, event: 'ORDER_RECEIVED'},
        {stateId: 6, event: 'ORDER_UPDATED_PROVIDER_RP'},
        {stateId: 3, event: 'ORDER_RECEIVED'}        
    ],
    FOOD: 'FOOD',
    NONFOOD: 'NONFOOD',
    events: {
      ORDER_DISPATCHED: 'ORDER_DISPATCHED'
    },
    listOfTripMode: [
      {value: 'TRIP_BETWEEN_ENTITIES', text: 'VIAJE ENTRE ENTIDADES'},
      {value: 'TRIP_TO_CUSTOMER', text: 'VIAJE A CLIENTES'}
    ],
    dispatchType: {
      RETURN: 'RETURN',
      NORMAL: 'NORMAL',
      EXPRESS: 'EXPRESS'
    }
  };

